var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4108 3.25995C27.2514 2.66799 26.9394 2.12826 26.5059 1.69479C26.0724 1.26131 25.5327 0.949288 24.9408 0.789951C22.7608 0.199951 14.0008 0.199951 14.0008 0.199951C14.0008 0.199951 5.24075 0.199951 3.06075 0.789951C2.46879 0.949288 1.92906 1.26131 1.49559 1.69479C1.06211 2.12826 0.750089 2.66799 0.590752 3.25995C0.183698 5.48322 -0.0138345 7.73978 0.000752436 9.99995C-0.0138345 12.2601 0.183698 14.5167 0.590752 16.74C0.750089 17.3319 1.06211 17.8716 1.49559 18.3051C1.92906 18.7386 2.46879 19.0506 3.06075 19.2099C5.24075 19.7999 14.0008 19.7999 14.0008 19.7999C14.0008 19.7999 22.7608 19.7999 24.9408 19.2099C25.5327 19.0506 26.0724 18.7386 26.5059 18.3051C26.9394 17.8716 27.2514 17.3319 27.4108 16.74C27.8178 14.5167 28.0153 12.2601 28.0008 9.99995C28.0153 7.73978 27.8178 5.48322 27.4108 3.25995ZM11.2008 14.2V5.79995L18.4708 9.99995L11.2008 14.2Z",
    fill: "#F24326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.9a2114a33b9abdd62f2b179734a1a556.svg";
export { ForwardRef as ReactComponent };